import App from './App.js';
import Environment from './env/Environment.js';

window.main = () => {
    App.create({env: Environment.withDefaults()}).run();
};